import osp_icons from './osp/icons/osp';
import wn_icons from './wackerneuson/icons/wacker-neuson';

/**
 * Definition of icon set keys
 *
 * Add a new key here if you want to register a new icon set. Don't forget to
 * amend the mapping in ICONSET_MAP!
 */
export enum IconsetKey {
  OSP = 'OSP',
  WN = 'WACKER_NEUSON',
}

/**
 * Mapping of icon sets
 *
 * Here you can create your own icon sets
 */
export const ICONSET_MAP: Record<IconsetKey, () => Record<string, string>> = {
  [IconsetKey.OSP]: () => osp_icons,
  [IconsetKey.WN]: () => ({ ...DEFAULT_ICONS, ...wn_icons }),
};

/**
 * The default icon set.
 *
 * This will be used if no icon is found or requested
 */
export const ICONSET_DEFAULT = IconsetKey.OSP;
const DEFAULT_ICONS = osp_icons;
